import React, { useContext } from 'react';
import { useWizard } from 'react-use-wizard';
import { Button } from '../../util/buttons';
import CardStep from '../../wizard/CardStep';
import { useSelector } from 'react-redux';
import { useGetUserClaimGroupAbilities } from '@rd-web-markets/market/dist/userAbilities';
export default function DownloadDataStep(_ref) {
  let {
    claimGroup,
    stepConfig,
    NavigationContext
  } = _ref;
  const {
    goToStep
  } = useWizard();
  const navigationDirection = useContext(NavigationContext);
  const user = useSelector(state => state.auth.user);
  const userAbilities = useGetUserClaimGroupAbilities({
    user,
    claimGroup
  });
  const goToChooseUploadDownloadStep = () => {
    navigationDirection.current = -1; // Going backward
    goToStep(stepConfig['ChooseUploadOrDownloadStep'].index);
  };
  const downloadProjectData = () => {
    goToStep(stepConfig['DownloadProjectDataStep'].index);
  };
  const downloadCostData = () => {
    goToStep(stepConfig['DownloadCostDataStep'].index);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardStep, {
    title: "What would you like to download?",
    NavigationContext: NavigationContext
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column h-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-auto d-flex justify-content-center gap-3"
  }, userAbilities.pages.any.canDownloadProjectData && /*#__PURE__*/React.createElement(Button, {
    onClick: downloadProjectData
  }, "Project Data"), userAbilities.pages.any.canDownloadCostData && /*#__PURE__*/React.createElement(Button, {
    onClick: downloadCostData
  }, "Cost Data")), /*#__PURE__*/React.createElement("div", {
    className: "mt-auto"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: goToChooseUploadDownloadStep
  }, "Go Back")))));
}